import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";


export default function DealersRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Dealers />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Dealers />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Dealers />
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => <Pages.Dealer match={ match } history={ history } exact /> }
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.Dealer />
            </Route>
        </Switch>
    );
}

